import { EodQuestionForSigning } from "../forms/EodQuestionForm/types"

type EodQuestionsForSigningAction = {
    type: "EOD_QUESTIONS_FOR_SIGNING_CHANGED"
    data: EodQuestionForSigning[]
}

export default function eodQuestionsForSigning(state: EodQuestionForSigning[] = [], action: EodQuestionsForSigningAction): EodQuestionForSigning[] {
    switch (action.type) {
        case "EOD_QUESTIONS_FOR_SIGNING_CHANGED":
            return action.data
        default:
            return state
    }
}
